import { FeaturesFlag, RemoteConfigValues } from './types';
import { FirebaseRemoteConfig } from '@capacitor-firebase/remote-config';
import { fetchAndActivate, getBoolean, getString } from 'firebase/remote-config';
import { isPlatform } from '@ionic/react';
import { environment } from '../../enviroments';
import { remoteConfig } from '../../firebase';

export const useRemoteConfig = () => {
  const remoteConfigInit = async (minimumFetchIntervalInSeconds?: number) => {
    if (isPlatform('hybrid')) {
      await FirebaseRemoteConfig.fetchConfig({
        minimumFetchIntervalInSeconds:
          minimumFetchIntervalInSeconds ?? environment.REMOTE_CONFIG.FETCH_INTERVAL_IN_SECONDS,
      });
      await FirebaseRemoteConfig.activate();
    } else {
      remoteConfig.settings.minimumFetchIntervalMillis =
        minimumFetchIntervalInSeconds ?? environment.REMOTE_CONFIG.FETCH_INTERVAL_IN_SECONDS;
      remoteConfig.defaultConfig = environment.REMOTE_CONFIG.DEFAULT_VALUES;
      await fetchAndActivate(remoteConfig);
    }
  };

  const isActiveFeature = async (key: keyof FeaturesFlag) => {
    if (isPlatform('hybrid') ?? isPlatform('mobileweb')) {
      const { value } = await FirebaseRemoteConfig.getBoolean({ key });
      return value;
    } else return getBoolean(remoteConfig, key);
  };

  const getConfigValue = async (configValue: keyof RemoteConfigValues): Promise<string> => {
    if (isPlatform('hybrid') ?? isPlatform('mobileweb')) {
      const { value } = await FirebaseRemoteConfig.getString({
        key: configValue,
      });
      return value;
    } else return getString(remoteConfig, configValue);
  };

  return {
    remoteConfigInit,
    getConfigValue,
    isActiveFeature,
  };
};
